import { faHtml5 } from '@fortawesome/free-brands-svg-icons';
import { faCss3Alt } from '@fortawesome/free-brands-svg-icons';
import { faBootstrap } from '@fortawesome/free-brands-svg-icons';
import { faSquareJs } from '@fortawesome/free-brands-svg-icons';
import { faSass } from '@fortawesome/free-brands-svg-icons';
import { faReact } from '@fortawesome/free-brands-svg-icons';

const projects = [
    [
        {
            id:1,
            title: 'Cineplus 1.0',
            desc: 'Proyecto final del curso de Desarrollo web en Coderhouse',
            tecs: [faHtml5, faCss3Alt, faSass, faBootstrap],
            img: 'projects-cineplus1.0.jpg',
            desktop: 'projects-cineplus1.0-desktop.png',
            mobile: '',
            link: 'https://fredy-rodrigo.github.io/proyecto-final-coderhouse/',
            repo: 'https://github.com/Fredy-Rodrigo/proyecto-final-coderhouse.git'
        }
        ,
        {
            id:2,
            title: 'Cineplus 2.0',
            desc: 'Proyecto final del curso de JavaScript en Coderhouse',
            tecs: [faHtml5, faCss3Alt, faSass ,faSquareJs],
            img: 'projects-cineplus2.0.jpg',
            desktop: 'projects-cineplus2.0-desktop.png',
            mobile: '',
            link: 'https://cineplus-js-coderhouse.netlify.app/',
            repo: 'https://github.com/Fredy-Rodrigo/Cineplus.git'
        }
        ,
        {
            id:3,
            title: 'JinzoStore',
            desc: 'Proyecto final del curso de React JS en Coderhouse',
            tecs: [faHtml5, faCss3Alt, faSass, faSquareJs, faReact],
            img: 'projects-jinzostore.jpg',
            desktop: 'projects-jinzostore-desktop.png',
            mobile: '',
            link: './',
            repo: 'https://github.com/Fredy-Rodrigo/JinzoStore.git'
        }
    ]
    ,
    [
        {
            id:4,
            title: 'Gimek Hogar',
            desc: 'Proyecto freelance para la tienda de electrodomesticos y productos de hogar Gimek Hogar',
            tecs: [faHtml5, faCss3Alt, faSass],
            img: 'projects-gimek.jpg',
            desktop: 'projects-gimek-desktop.png',
            mobile: 'projects-gimek-mobile.jpg',
            link: 'https://gimek-hogar.netlify.app/',
            repo: 'https://github.com/Fredy-Rodrigo/Gimek-hogar.git'
        }
        ,
        {
            id:5,
            title: 'Inventronix 3D',
            desc: 'Proyecto freelance para un emprendimiento de servicios de impresión 3d',
            tecs: [faHtml5, faCss3Alt, faSass, faSquareJs],
            img: 'projects-inventronix.jpg',
            desktop: 'projects-inventronix-desktop.png',
            mobile: 'projects-inventronix-mobile.png',
            link: 'https://inventronix3d.com/',
            repo: 'https://github.com/Fredy-Rodrigo/Inventronix.git'
        }
    ]
]

export default projects;